export default {
  getDiscoverFeedInterestsQueryKey: () => ["discover_feed_interests"],
} as const;
